import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  displayDateTime,
  parseDateFromUtc,
} from "../../../../../../Helpers/utils/utils";
import "./LogDetailsModal.scss";

function LogDetailsModal({ log, show, onHide, ...props }) {
  const [t] = useTranslation();
  const [showException, setShowException] = useState(true);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      dialogClassName="log-detail-modal"
    >
      <Modal.Header className="log-detail-modal-header" closeButton>
        <h2 className="title">{t("LogInformation")}</h2>
      </Modal.Header>
      {log && (
        <Modal.Body className={"log-detail-modal-wrapper"}>
          <div className="info-wrapper">
            <div className="column">
              <h4 className="subtitle">{t("Fields")}</h4>
              <ul className="info-row-wrapper">
                {Object.keys(log)
                  .filter(
                    (x) =>
                      x !== "properties" && x !== "exception" && x !== "user"
                  )
                  .map((x) => {
                    let value = log[x];
                    if (x === "timeStamp") {
                      value = displayDateTime(parseDateFromUtc(log[x]));
                    }
                    return (
                      <li className="info-row" key={"log-details-field-" + x}>
                        <div className="key uppercase" title={x}>
                          {x + ": "}
                        </div>
                        <div className="value ellipsis" title={value}>
                          {value}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className="column">
              <h4 className="subtitle">{t("Properties")}</h4>
              <ul className="info-row-wrapper">
                {Object.keys(log.properties)
                  .filter((x) => !Object.keys(log).some((y) => x === y))
                  .map((x) => (
                    <li
                      className="info-row"
                      key={"log-details-properties-" + x}
                    >
                      <div className="key uppercase" title={x}>
                        {x + ": "}
                      </div>
                      <div className="value ellipsis" title={log.properties[x]}>
                        {log.properties[x]}
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {log.exception && (
            <div className="exception">
              <div
                className="exception-title"
                onClick={() => setShowException(!showException)}
              >
                <h4 className="subtitle">{t("Exception")}</h4>
                <span className="icon">
                  {showException ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
              </div>

              {showException && (
                <div className="exception-wrapper">
                  <div className="code">{log.exception}</div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      )}
    </Modal>
  );
}
export default LogDetailsModal;
